<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsSample-fabricSeries',
  components: {
    PageTable,
  },
}
</script>
